import { FunctionsError } from 'firebase/functions';
import CliError from '../../../utilities/CliError';
import getCallableFirebaseFunction from '../../../utilities/getCallableFirebaseFunction';

export default async function releaseBuild({
  appId,
  buildId,
}: {
  appId: string;
  buildId: string;
}): Promise<void> {
  try {
    await getCallableFirebaseFunction('releaseBuild')({ appId, buildId });
  } catch (e) {
    if (isFirebaseFunctionError(e)) {
      // Preserve the original Firebase error message
      const errorType =
        e.code === 'failed-precondition' || e.code === 'not-found'
          ? 'build-error'
          : 'error';
      throw CliError.from(e, errorType);
    } else {
      throw new CliError('Unexpected internal error while releasing build');
    }
  }
}

function isFirebaseFunctionError(error: unknown): error is FunctionsError {
  return Boolean(
    typeof error === 'object' &&
    error &&
    'code' in error &&
    typeof (error as any).code === 'string',
  );
}
